import { fade, makeStyles } from "@material-ui/core";
import { grey } from "@material-ui/core/colors";

const multilineTextareaHeight = 110;
export default makeStyles((theme) => ({
  paper: {
    borderRadius: theme.spacing(1),
    backgroundColor: theme.palette.common.white,
    outline: "none !important",
    "&:focus": {
      outline: "none !important",
    },
    padding: theme.spacing(3, 3, 2, 3),
  },
  autocompletePaper: {
    color: theme.palette.contrastText.main,
    backgroundColor: fade(theme.palette.otherElementsBackground.main, 1),
    borderColor: theme.palette.separator.main,
  },
  formTitle: {
    marginBottom: theme.spacing(2),
  },
  formSubTitle: {
    fontSize: 14,
    color: grey[600],
  },
  content: {
    paddingTop: theme.spacing(3),
  },
  contrastText: {
    color: theme.palette.contrastText.main,
  },
  input: {
    marginBottom: theme.spacing(3),
    width: "100%",
    "& button svg": {
      color: theme.palette.contrastText.main,
      fill: theme.palette.contrastText.main,
    },
    "& input": {
      color: theme.palette.contrastText.main,
      "&.Mui-disabled": {
        color: grey[500],
      },
      "&:-webkit-autofill": {
        WebkitBoxShadow: `0 0 0 1000px ${theme.palette.autofillBackground.main} inset !important`,
        WebkitTextFillColor: `${theme.palette.contrastText.main} !important`,
        caretColor: theme.palette.contrastText.main,
        "&:hover": {
          WebkitBoxShadow: `0 0 0 1000px ${theme.palette.autofillBackground.main} inset !important`,
          WebkitTextFillColor: `${theme.palette.contrastText.main} !important`,
        },
        "&:active": {
          WebkitBoxShadow: `0 0 0 1000px ${theme.palette.autofillBackground.main} inset !important`,
          WebkitTextFillColor: `${theme.palette.contrastText.main} !important`,
        },
        "&:focus": {
          WebkitBoxShadow: `0 0 0 1000px ${theme.palette.autofillBackground.main} inset !important`,
          WebkitTextFillColor: `${theme.palette.contrastText.main} !important`,
        },
      },
    },
    "& fieldset": {
      borderColor: theme.palette.secondaryContrast.main,
    },
    "& label": {
      color: theme.palette.placeholder.main,
      "&.Mui-disabled": {
        color: grey[500],
      },
    },
    "& label.Mui-focused": {
      color: theme.palette.primary.main,
      "& span": {
        color: theme.palette.primary.main,
      },
    },
    "& label.Mui-disabled": {
      color: theme.palette.inputLabelDisabled.main,
    },
    "& div": {
      "&.Mui-error fieldset": {
        borderColor: `${theme.palette.error.main} !important`,
      },
      "&:hover fieldset": {
        borderColor: `${theme.palette.contrastText.main} !important`,
      },
      "&.Mui-focused fieldset": {
        borderColor: `${theme.palette.primary.main} !important`,
      },
    },
  },
  warnedInput: {
    "& .MuiOutlinedInput-root": {
      borderColor: theme.palette.warning.main,
      "& fieldset": {
        borderColor: theme.palette.warning.main,
      },
    },
    "& .MuiFormLabel-root": {
      color: theme.palette.warning.main,
    },
  },
  ellipsis: {
    maxWidth: "100%",
    overflow: "hidden",
    whiteSpace: "nowrap",
    textOverflow: "ellipsis",
  },
  inputLabel: {
    color: theme.palette.placeholder.main,
  },
  multilineInput: {
    paddingTop: "5px",
    marginBottom: theme.spacing(3),
    width: "100%",
    overflow: "scroll",
    "& label": {
      top: 5,
    },
  },
  multilineTextarea: {
    resize: "vertical",
    overflow: "visible !important",
  },
  inputs: {
    "&>:nth-child(1)": {
      marginTop: theme.spacing(3),
    },
    "&>:nth-last-child(1)": {
      marginBottom: 0,
    },
  },
  datePicker: {
    "& .MuiGrid-grid-xs-1": {
      maxWidth: "inherit",
    },
  },
  inputGroup: {
    display: "flex",
    justifyContent: "space-between",
    "& div + div": {
      marginLeft: theme.spacing(3),
    },
  },
  menuItem: {
    minHeight: "48px",
  },
  actions: (isLeftAction) => ({
    display: "flex",
    justifyContent: isLeftAction ? "space-between" : "flex-end",
    paddingTop: theme.spacing(2),
  }),
  action: {
    fontWeight: 600,
    padding: theme.spacing(1),
    height: "40px",
  },
  selectIcon: {
    fill: theme.palette.contrastText.main,
  },
  multiselectChip: {
    marginRight: theme.spacing(1),
    borderColor: grey[300],
    color: theme.palette.common.black,
  },
  multiselectMenuList: {
    maxHeight: "500px",
  },
  select: {
    color: theme.palette.contrastText.main,
    "&.Mui-disabled": {
      color: grey[500],
      WebkitTextFillColor: grey[500],
    },
  },
  menuList: {
    background: theme.palette.otherElementsBackground.main,
    color: theme.palette.contrastText.main,
  },
  multiselectMenuItem: {
    minHeight: "48px",
    paddingLeft: 0,
  },
  multiselectMenuItemSelected: {
    backgroundColor: "transparent !important",
    "&:hover": {
      backgroundColor: `${grey[100]} !important`,
    },
  },
  loader: {
    marginLeft: theme.spacing(1),
  },
  selectValue: {
    textOverflow: "ellipsis",
    gap: "16px",
    overflow: "hidden",
    maxWidth: "90%",
  },
}));
